import { render, staticRenderFns } from "./multiple-room.vue?vue&type=template&id=6c33a742&scoped=true"
import script from "./multiple-room.vue?vue&type=script&lang=js"
export * from "./multiple-room.vue?vue&type=script&lang=js"
import style0 from "./multiple-room.vue?vue&type=style&index=0&id=6c33a742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c33a742",
  null
  
)

/* custom blocks */
import block0 from "./multiple-room.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports